import { useEffect } from 'react'

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { deDE, plPL, enUS, frFR } from '@mui/x-date-pickers/locales'
import dayjs from 'dayjs'
import 'dayjs/locale/pl'
import 'dayjs/locale/de'
import 'dayjs/locale/fr'
import 'dayjs/locale/en'
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'

import { DatePickerValue } from './types'
import { DateTimePicker } from '@/Atomic/Molecules/Inputs/DateTimePicker'

const germanLocale =
  deDE.components.MuiLocalizationProvider.defaultProps.localeText
const polishLocale =
  plPL.components.MuiLocalizationProvider.defaultProps.localeText
const englishLocale =
  enUS.components.MuiLocalizationProvider.defaultProps.localeText
const frenchLocale =
  frFR.components.MuiLocalizationProvider.defaultProps.localeText

const localeMap: { [key: string]: object } = {
  de: germanLocale,
  pl: polishLocale,
  en: englishLocale,
  fr: frenchLocale,
}

interface LogTimeFormDatePickerProps {
  defaultValue?: DatePickerValue
  onChange: (...event: unknown[]) => void
}

export const LogTimeFormDatePicker = ({
  defaultValue,
  onChange,
}: LogTimeFormDatePickerProps) => {
  const { t } = useTranslation()
  const currentLocale = i18n.resolvedLanguage || 'en'

  useEffect(() => {
    dayjs.locale(currentLocale)
  }, [currentLocale])

  const weekdayFormatter = (weekday: dayjs.Dayjs) => {
    return weekday.locale(currentLocale).format('ddd')
  }

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={currentLocale}
      localeText={localeMap[currentLocale]}
    >
      <DateTimePicker
        title={t('timeTracking.columns.date')}
        name="date"
        views={['year', 'month', 'day']}
        className="d-flex flex-column gap-2 w-100"
        openTo="day"
        format="dddd, D MMMM YYYY"
        dayOfWeekFormatter={weekdayFormatter}
        clearable={false}
        defaultValue={defaultValue}
        timezone="system"
        onChange={onChange}
      />
    </LocalizationProvider>
  )
}
